module.exports = __webpack_public_path__ + "static/media/close.e35d7f00.svg";